import { createSelector } from 'reselect';

import { AUTOUPDATE_STATE } from '../../../../../../common/electron/electronConstants';

export const electronAppVersionSelector = (state) => state.getIn(['app', 'electron', 'appVersion']);

const electronUpdateSelector = createSelector(
    (state) => state.getIn(['app', 'electron', 'autoUpdate']),
    electronAppVersionSelector,
    (state) => state.getIn(['app', 'electron', 'autoUpdateProgress']),
    (autoUpdate, version, updateProgress) => ({
        autoUpdate,
        version,
        updateProgress,
        updateReady: autoUpdate === AUTOUPDATE_STATE.READY,
    }),
);

export default electronUpdateSelector;
